<template>
	<div class="pl-date">
		<link-input :value="showValue"
					v-bind="inputBinding"

					ref="input"
					:suffix-icon="!!datetime?'link-icon-datetime':'link-icon-calendar'"
					:type="type"
					:color="color"
					:size="size"
					:shape="shape"
					:dashed="dashed"
					:long="long"
					:prefixIcon="prefixIcon"
					:disabled="lv_disabled"
					input-readonly
					:hide-clear-icon="hideClearIcon"
					:clear-on-click-delete-icon="false"
					:required="required"
					:validate-on-init="validateOnInit"
					:rules="rules"
					@click-suffix-icon="!lv_disabled&&!lv_readonly && pl_clear()"
					@click="!lv_disabled&&!lv_readonly && pl_click()">
			<link-popper
				slot="prepend"
				ref="popper"
				v-bind="popperBinding"
				v-model="p_show"
				:reference="!lv_mounted?null:$refs.input">
				<div class="pl-date-popper">
					<pl-date-range-panel
						ref="panel"
						v-if="range"
						:start.sync="p_start"
						:end.sync="p_end"

						:display-format="p_df"
						:value-format="p_vf"
						:max-date="p_maxDate"
						:min-date="p_minDate"
						:view="view"
						:datetime="datetime"
						:decode-date-string="p_decodeDateString"
						:now-year="nowYear"
						:now-month="nowMonth"

						@close="p_close"
						@change="pl_change"/>
					<pl-date-single-panel
						ref="panel"
						v-else
						:value="p_value"

						:display-format="p_df"
						:value-format="p_vf"
						:max-date="p_maxDate"
						:min-date="p_minDate"
						:view="view"
						:datetime="datetime"
						:now-year="nowYear"
						:now-month="nowMonth"
						:now-day="nowDay"
						:decode-date-string="p_decodeDateString"

						@input="p_valueChange"
						@close="p_close"
						@change="pl_change"/>
				</div>
			</link-popper>
		</link-input>
	</div>
</template>

<script>
	import PlDatePanel from "./pl-date-panel";
	import {DateUtil} from "./index";
	import PlDateSinglePanel from "./pl-date-single-panel";
	import PlDateRangePanel from "./pl-date-range-panel";
	import {EditMixin, MountedMixin} from "../../mixins";

	export default {
		name: "pl-date",
		components: {PlDateRangePanel, PlDateSinglePanel, PlDatePanel},
		mixins: [MountedMixin, EditMixin],
		props: {
			value: {type: String,},
			start: {type: String},
			end: {type: String},
			max: {type: String},
			min: {type: String},
			show: {type: Boolean, default: false},
			displayFormat: {type: String},
			valueFormat: {type: String},
			datetime: {type: Boolean},
			range: {type: Boolean},
			view: {type: String, default: 'date'},
			before: {type: Function},

			type: {type: String, default: 'line',},
			color: {type: String, default: 'info',},
			size: {type: String, default: 'default',},
			shape: {type: String, default: 'none',},
			dashed: {type: Boolean,},
			long: {type: Boolean,},
			prefixIcon: {type: String},
			placeholder: {type: String, default: '选择日期'},
			regexp: {type: RegExp},
			width: {},
			hideClearIcon: {type: Boolean},
			required: {type: Boolean},
			rules: {type: Array | String},
			validateOnInit: {type: Boolean,},

			input: {},
			defaultTime: {type: String, default: ''},    // example: default-time="00:00:00,23:59:59"  注： 可以适用于 range情况下 且不是datetime的时间选择器
		},
		watch: {
			value(val) {
				if (this.p_value !== val) this.p_value = val
			},
			p_value(val) {
				if (this.value !== val) this.$emit('input', val)
			},
			start(val) {
				if (this.p_start !== val) this.p_start = val
			},
			p_start(val) {
				if (this.start !== val) this.$emit('update:start', val)
			},
			end(val) {
				if (this.p_end !== val) this.p_end = val
			},
			p_end(val) {
				if (this.end !== val) this.$emit('update:end', val)
			},
			show(val) {
				if (this.p_show !== val) this.p_show = val
			},
			p_show(val) {
				if (this.show !== val) this.$emit('update:show', val)
				if (val) {
					this.$nextTick(async () => {
						const times = this.$lv.$dom.findComponentsDownward(this, 'pl-time')
						times.forEach(time => {
							time.$on('show', async () => {
								await this.$lv.nextTick()
								this.$refs.popper.addRelateEl(time.$refs.panel.$el)
							})
							time.$on('hide', async () => {
								this.$refs.popper.removeRelateEl(time.$refs.panel.$el)
							})
						})
					})
				} else {
					this.$nextTick(() => !!this.$refs.panel && this.$refs.panel.p_reset())
				}
			},
		},
		data() {
			const nowDate = new Date()
			return {
				p_value: this.value,
				p_start: this.start,
				p_end: this.end,
				p_show: this.show,

				nowDate,
				nowYear: nowDate.getFullYear(),
				nowMonth: nowDate.getMonth(),
				nowDay: nowDate.getDate(),
			}
		},
		computed: {
			p_df() {
				return DateUtil.getDefaultDisplayFormat(this.displayFormat, this.datetime, this.view)
			},
			p_vf() {
				return DateUtil.getDefaultValueFormat(this.valueFormat, this.datetime, this.view)
			},
			showValue() {
				if (!this.range) {
					if (!this.p_value) return null
					return this.$lv.$utils.dateFormat(this.$lv.$utils.dateParse(this.p_value, this.p_vf), this.p_df)
				} else {
					if (!this.p_start || !this.p_end) return null
					return `${this.$lv.$utils.dateFormat(this.$lv.$utils.dateParse(this.p_start, this.p_vf), this.p_df)}  ~  ${this.$lv.$utils.dateFormat(this.$lv.$utils.dateParse(this.p_end, this.p_vf), this.p_df)}`
				}
			},
			p_maxDate() {
				if (!this.max) return null
				const date = this.$lv.$utils.dateParse(this.max, this.p_vf)

				if (this.view === 'year') {
					date.setDate(1)
					date.setMonth(0)
				}
				if (this.view === 'month') {
					date.setDate(1)
				}
				return date
			},
			p_minDate() {
				if (!this.min) return null
				const date = this.$lv.$utils.dateParse(this.min, this.p_vf)

				if (this.view === 'year') {
					date.setDate(1)
					date.setMonth(0)
				}
				if (this.view === 'month') {
					date.setDate(1)
				}
				return date
			},
			inputBinding() {
				return Object.assign({
					inputReadonly: true,
					placeholder: this.placeholder,
					width: this.width != null ? this.width : (!!this.range && !!this.datetime) ? '300px' : '200px'
				}, this.simpleBinding, this.input)
			},
			popperBinding() {
				return Object.assign({
					width: null,
					height: null,
					disabledEqual: true,
				}, this.popper)
			},
		},
		methods: {
			p_valueChange(val) {
				this.p_value = val
			},
			async p_close() {
				await this.$lv.nextTick()
				this.$refs.popper.hide()
			},
			async pl_click() {
				if (!!this.before) await this.before()
				this.$refs.popper.p_show ?
					this.$refs.popper.hide()
					:
					this.$refs.popper.show()
			},
			pl_clear() {
				this.p_value = null
				this.p_start = null
				this.p_end = null
				this.p_show = false
				this.$nextTick(() => this.$emit('change', this.range ? {start: this.p_start, end: this.p_end} : this.p_value))
			},
			p_decodeDateString(str, type = 'start') {
				if (str === '') {
					str = null
				}
				const ret = {
					pickYear: null,
					pickMonth: null,

					year: null,
					month: null,
					day: null,

					hour: type === 'start' ? 0 : 23,
					minute: type === 'start' ? 0 : 59,
					second: type === 'start' ? 0 : 59,

					mode: this.view,

					date: null,
					time: null,
					timeString: null,
					maxTimeString: null,
					minTimeString: null,
				}
				ret.timeString = `${this.$lv.$utils.zeroize(ret.hour)}:${this.$lv.$utils.zeroize(ret.minute)}:${this.$lv.$utils.zeroize(ret.second)}`
				if (str == null) {
					ret.pickYear = this.nowYear
					ret.pickMonth = this.nowMonth
					return ret
				} else {
					const date = this.$lv.$utils.dateParse(str, this.p_vf)
					ret.date = date
					if (this.view === 'year') {
						date.setDate(1)
						date.setMonth(0)
					} else if (this.view === 'month') {
						date.setDate(1)
					}
					if (!this.datetime) {
						date.setHours(type === 'start' ? 0 : 23)
						date.setMinutes(type === 'start' ? 0 : 59)
						date.setSeconds(type === 'start' ? 0 : 59)
					}
					const dateInfo = this.$lv.$utils.decodeDate(date)
					Object.assign(ret, dateInfo)
					ret.pickYear = dateInfo.year
					ret.pickMonth = dateInfo.month

					if (this.datetime) {
						if (!!this.max) {
							const maxDate = this.$lv.$utils.dateParse(this.max, this.p_vf)
							const {year, month, day, hour, minute, second} = this.$lv.$utils.decodeDate(maxDate)
							if (year === ret.year && month === ret.month && day === ret.day) {
								ret.maxTimeString = `${this.$lv.$utils.zeroize(hour)}:${this.$lv.$utils.zeroize(minute)}:${this.$lv.$utils.zeroize(second)}`
							}
						}
						if (!!this.min) {
							const minDate = this.$lv.$utils.dateParse(this.min, this.p_vf)
							const {year, month, day, hour, minute, second} = this.$lv.$utils.decodeDate(minDate)
							if (year === ret.year && month === ret.month && day === ret.day) {
								ret.minTimeString = `${this.$lv.$utils.zeroize(hour)}:${this.$lv.$utils.zeroize(minute)}:${this.$lv.$utils.zeroize(second)}`
							}
						}
					}
				}

				return ret
			},
			pl_change() {
				this.changeValue();
			},
			/**
			 * @createdBy 常九福
			 * @date 2020/8/24
			 * @methods: changeValue
			 * @para: start 开始时间 end 结束时间
			 * @description: 增加默认值 时分秒
			 **/
			changeValue() {
				const defaultTimeArr = this.defaultTime.split(',');
				const startValue = this.defaultTime && !this.datetime ? this.p_start + ' ' + defaultTimeArr[0] : this.p_start
				const endValue = this.defaultTime && !this.datetime ? this.p_end + ' ' + defaultTimeArr[1] : this.p_end
				this.$emit('update:start', startValue)
				this.$emit('update:end', endValue)
				this.$nextTick(() => this.$emit('change', this.range ? {start: startValue, end: endValue} : this.p_value))
			},

		}
	}
</script>

<style lang="scss">

	$dateItemSize: 32px;
	$dateBorderRadius: 4px;
	$dateInnerItemSize: 26px;

	@include themeify {
		.pl-date {
			@include public-style;
			display: inline-block;
		}

		.pl-date-popper {
			padding: 0 8px 0px 8px;

			.pl-date-time {
				font-size: 12px;
				color: pl-var(color-primary);
			}
		}

		.pl-date-day-panel {
			@include public-style;
			font-size: 12px;
			box-sizing: border-box;
			display: inline-flex;
			width: $dateItemSize*7+16px;
			flex-wrap: wrap;
			color: pl-var(color-normal-content);
			user-select: none;
			padding: 0 8px;

			.pl-date-day-panel-item-wrapper {
				height: $dateItemSize;
				width: $dateItemSize;
				display: inline-flex;
				align-items: center;
				justify-content: center;
				cursor: pointer;
				margin-bottom: 6px;

				&.pl-date-day-panel-item-wrapper-title {
					color: pl-var(color-normal-content);
					border-bottom: #f6f6f6 solid 1px;
				}

				.pl-date-day-panel-item {
					height: $dateInnerItemSize;
					width: 100%;
					display: inline-flex;
					align-items: center;
					justify-content: center;

					.pl-date-day-panel-item-inner {
						height: $dateInnerItemSize;
						width: $dateInnerItemSize;
						display: flex;
						align-items: center;
						justify-content: center;
						border-radius: $dateBorderRadius;

					}

					&.pl-date-day-panel-item-today {
						.pl-date-day-panel-item-inner {
							background-color: pl-var(color-success);
							border-radius: $dateItemSize;
							color: white;
						}
					}

					&.pl-date-day-panel-item-other-month {
						color: #dfdfdf;
						font-weight: normal;
					}

					&:hover:not(.pl-date-day-panel-item-disabled) {
						.pl-date-day-panel-item-inner {
							background-color: pl-var(color-primary-light);
							color: pl-var(color-normal-content);
						}
					}

					&.pl-date-day-panel-item-light:not(.pl-date-day-panel-item-disabled) {
						background-color: pl-var(color-primary-light);
					}

					&.pl-date-day-panel-item-disabled {
						cursor: not-allowed;

						.pl-date-day-panel-item-inner {
							color: pl-var(color-error);
							border-radius: $dateBorderRadius;
							font-weight: normal;
						}
					}

					&.pl-date-day-panel-item-active {
						.pl-date-day-panel-item-inner {
							background-color: pl-var(color-primary);
							border-radius: $dateBorderRadius;
							color: white;
						}
					}
				}
			}
		}

		.pl-date-header {
			@include public-style;
			height: 40px;
			width: $dateItemSize*7+16px;
			display: flex;
			flex-direction: row;
			user-select: none;

			.pl-date-header-left, .pl-date-header-right {
				flex: 1;
				padding: 0 6px;
				box-sizing: border-box;
				font-size: 12px;
			}

			.pl-date-header-center {
				.pl-date-header-label {
					padding: 4px 9px;
					font-size: 14px;

					&:hover {
						border-radius: 4px;
						background-color: pl-var(color-primary-light);
					}
				}
			}

			.pl-date-header-left, .pl-date-header-center, .pl-date-header-right {
				height: 100%;
				display: flex;
				align-items: center;
				justify-content: center;
				color: pl-var(color-normal-content);
				cursor: pointer;

				.pl-date-header-label {
					&:not(:last-child) {
						margin-right: 3px;
					}

					&:hover {
						color: pl-var(color-primary);
					}
				}
			}

			.pl-date-header-left {
				justify-content: flex-start;
			}

			.pl-date-header-right {
				justify-content: flex-end;
			}
		}

		.pl-date-month-panel {
			@include public-style;
			width: 100%;
			height: 100%;
			padding: 9px;

			.pl-date-month-panel-content-wrapper {
				width: 100%;
				height: 100%;

				.pl-date-month-panel-item-wrapper {
					display: inline-flex;
					width: 33.33%;
					height: 55px;
					align-items: center;
					justify-content: center;

					.pl-date-month-panel-item {
						border-radius: 4px;
						cursor: pointer;
						height: 24px;
						width: 50px;
						font-size: 12px;
						display: flex;
						align-items: center;
						justify-content: center;

						&:hover, &.pl-date-month-panel-item-pick-month {
							background-color: pl-var(color-primary-light);
						}

						&.pl-date-month-panel-item-now {
							background-color: pl-var(color-success);
							color: white;
						}

						&.pl-date-month-panel-item-active {
							background-color: pl-var(color-primary);
							color: white;
						}

						&.pl-date-month-panel-item-disabled {
							color: pl-var(color-error);
							background-color: white;
							cursor: not-allowed;
						}
					}
				}
			}
		}

		.pl-date-panel {
			@include public-style;
			width: 196px;
			display: inline-block;

			.pl-date-panel-body {
				width: $dateItemSize*7+16px;
				height: $dateItemSize*7+6*6;
			}
		}

		.pl-date-range-panel {
			display: inline-flex;
			align-items: center;

			.pl-date-range-panel-left {
				margin-right: 12px;
			}
		}

		.pl-date-year-panel {
			@include public-style;
			width: 100%;
			height: 100%;
			padding: 9px;

			.pl-date-year-panel-content {
				width: 100%;

				.pl-date-year-panel-item-wrapper {
					display: inline-flex;
					width: 33.33%;
					align-items: center;
					justify-content: center;
					height: 44px;
					font-size: 12px;

					.pl-date-year-panel-item {
						padding: 4px 9px;
						cursor: pointer;
						border-radius: 4px;

						&:hover, &.pl-date-year-panel-item-pick-year {
							background-color: pl-var(color-primary-light);
						}

						&.pl-date-year-panel-item-now {
							background-color: pl-var(color-success);
							color: white;
						}

						&.pl-date-year-panel-item-active {
							background-color: pl-var(color-primary);
							color: white;
						}

						&.pl-date-year-panel-item-disabled {
							color: pl-var(color-error);
							background-color: white;
							cursor: not-allowed;
						}
					}
				}
			}
		}
	}
</style>
